// JavaScript Document
//components/configuration/ConfigStandard.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
//import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import AddIcon from '@material-ui/icons/AddCircle';
import Popover from '@material-ui/core/Popover';
//import DisplayMode from './DisplayMode';
import PowerPicker from '../forms/PowerPicker';
import PowerInterval from './PowerInterval';
import Setting from './Setting';
import SettingInterval from './SettingInterval';
import FlatSetting from './FlatSetting';
import dsutils from './Utils';
const utils = dsutils();

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
	pos: {
		marginBottom:12,
	},
	center : {
		textAlign: 'center'
	},
	interval : {
		textAlign: 'center',
		padding: 2,
		margin: 2,
		display: 'inline-block',
		maxWidth: 330,
		minWidth: 165,
	},
	newIntervalButton : {
		textAlign: 'center',
		margin: 2,
		maxWidth: 330,
		minWidth: 165
	},
	powers : {
		maxWidth: 350,
		display: 'inline-block'
	},
	chip : {
			margin: theme.spacing(0.5),
			//fontSize:'0.9em'
		},
	
}));

export default function DaysettingStandard(props) {
  const classes = useStyles();
	//Inherited props
	//sign = sign object
	//handleSend = server request
	//config = config object
	//dsid = daysetting id
	//loadedToken = timestamp of last server load
  	const {sign, config, dsid, loadedToken, onChange, displays} = props;

	//State variables that can be updated independent of inherited props
	const [settings, setSettings] = React.useState(utils.model.daysetting);
  	const [token, setToken] = React.useState(null);
  	const [did, setDid] = React.useState(0);
	const [intervals, setIntervals] = React.useState([]);
	
	//Set initial state of interval popper
	const [popper, setPopper] = React.useState({
		anchor: null,
		open : false,
		interval : []
	});
	
	//Power interval update handler
	const handleUpdatePowerInterval = (target, intervals) => {
		let newSettings = Object.assign({}, settings);
		newSettings[target] = intervals;
		setSettings(newSettings);
		handleChange(newSettings);
	};
	
	//Setting update handler
	const handleUpdateSettingInterval = (key, newSettings) => {
		console.log("Handle update setting interval "+key);
		console.log(newSettings);
		let newIntervals = Object.assign([], intervals);
		newIntervals.splice(key, 1, newSettings);
		//setIntervals(newIntervals);
		compileDaysettingIntervals(newIntervals);
	}
	
	//Update default settings handler
	const handleUpdateDefaultSettings = (updatedSettings) => {
		let newSettings = Object.assign({}, settings);
		newSettings.speed.default = updatedSettings.speed;
		newSettings.op.default = updatedSettings.op;
		newSettings.threshold.default = updatedSettings.threshold;
		newSettings.maxspeed.default = updatedSettings.maxspeed;
		setSettings(newSettings);
		handleChange(newSettings);
	}
	
	//handle change dim setting times
	const handleDimChange = (times, type) => {
		let newSettings = Object.assign({}, settings);
		newSettings.dim = times;
		setSettings(newSettings);
		handleChange(newSettings);
		
	};
	//helper function to fill an interval with current time
	const intervalDefaultFill = () => {
		var d = new Date();
		var curhour = d.getHours() === 23 ? 22 : d.getHours();
		var nexthour = d.getHours() === 23 ? 23 : d.getHours()+1;
		return [curhour+':00:00', nexthour+':00:00'];
	}
	
	//Close interval popper
	const closePopper = () => {
		setPopper({
			anchor: null,
			open : false,
			interval : []
		});
	}
	
	//handle click add setting group
	const handleClickAddSettingGroup = (e) => {
		//var times = intervalDefaultFill();
		//console.log(times);
		setPopper({
			anchor: e.currentTarget,
			open:true,
			interval: intervalDefaultFill()
		});
	}
	
	//handle add setting group
	const handleAddSettingGroup = (interval) => {
		let newIntervals = utils.control.setting.extractIntervals(settings);//Object.assign([], intervals);
		let newGroup = Object.assign({}, utils.model.settingGroup);
		newGroup.intervals = [];
		newGroup.intervals.push(interval);
		//newIntervals.push(utils.model.settingGroup);
		newIntervals.push(newGroup);
		setIntervals(newIntervals);
		compileDaysettingIntervals(newIntervals);
		closePopper();
	}
	
	//Apply Daysetting Interval Changes
	const compileDaysettingIntervals = (newIntervals) => {
		let newSettings = utils.control.setting.compile(settings, newIntervals);
		setSettings(newSettings);
		handleChange(newSettings);
	}
	
	//handle any changes to current daysettings and update parent
	const handleChange = (newSettings) => {
		if(onChange){
			onChange(dsid, newSettings);
		}
	}
	
	//update state on props changes
  	React.useEffect(() => {
		//Only update from new load from server
		//Ensure changes in-progress are preserved
	if(
		//inherited daysetting ID is null
		dsid === 0 || 
		dsid === undefined || 
		dsid === null || 
		dsid === "0" || 
		//inherited daysetting has changed
		dsid !== did || 
		//updated from server
		loadedToken !== token) {
			setSettings(config.daysettings[dsid]);
		 	setDid(dsid);
			setToken(token);
			setIntervals(utils.control.setting.extractIntervals(config.daysettings[dsid]));
	 	}
	  	//setIntervals(utils.control.setting.extractIntervals(config.daysettings[dsid]));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);

	
	

	//check if the daysetting will support more intervals
	const isIntervalsMax = () => {
		let i = 0;
		//let newIntervals = utils.control.setting.extractIntervals(settings);
		intervals.forEach(row => i+=row.intervals.length);
		//max intervals is 3
		if(i > 2){
			return false;
		}
		return true;
	}
	
	//render new daysetting interval button
	const newSettingInterval = () => {
		if(isIntervalsMax() === true){
			//display it
			return (
				<Button
					variant="outlined"
					color="primary"
					size="large"
					onClick={handleClickAddSettingGroup}
					className={classes.newIntervalButton}
					startIcon={<AddIcon />}
				>
					Add
				</Button>
			)
		} else {
			return "";
		}
	}
	const renderDim = () => {
		if(sign){
			if(sign.options.length > 0){
				if(sign.options.findIndex(opt => opt.cfg_reference === 'autoDim') !== -1)
					return '';
			}
		}
		return (
			<Typography variant="h6" component="h3">
				Brightness
				<FlatSetting
					settings={settings.dim}
					onChange={handleDimChange}
					type="dim"
				/>
			</Typography>
		);
	}
	
	
  if(dsid > 0){
  	return (
    	<div className={classes.root}>
			<Grid container>
				<Grid sm={4} md={3}>
					<div className={classes.powers}>
						{utils.model.powers.map((row, e) => (
							<PowerInterval key={e} type={row.type} label={row.label} intervals={settings[row.type]} onChange={handleUpdatePowerInterval} />
						))}
						{renderDim()}
					</div>
				</Grid>
				<Grid sm={8} md={9}>
					<Grid container justifyContent="space-around">
						<Setting sign={sign} config={config} settings={{speed:settings.speed.default, threshold:settings.threshold.default, maxspeed:settings.maxspeed.default, op:settings.op.default}} onChange={handleUpdateDefaultSettings} displays={displays}>
							<Chip
								size="medium"
								label="Default"
								color="primary"
								className={classes.chip}
							/>
						</Setting>
						{intervals.map((row, e) => (
							<SettingInterval key={e} id={e} sign={sign} config={config} settings={row} enableAdd={isIntervalsMax()} onChange={handleUpdateSettingInterval} displays={displays} />
						))}
						{newSettingInterval()}
					</Grid>
				</Grid>
			</Grid>
			<Popover
					id={did+'_newintervalpopper'}
					open={popper.open}
					anchorEl={popper.anchor}
					onClose={closePopper}
					anchorOrigin={{
								  vertical:'center',
								  horizontal: 'center'
								 }}
					transformOrigin={{
									 vertical:'top',
									 horizontal:'center'
									}}
				>
				<PowerPicker times={popper.interval} onChange={handleAddSettingGroup} />
			</Popover>
    	</div>
  		);

	} else {
		return (
			<div>loading {dsid}</div>
		);
	}
}
